module.exports = __webpack_public_path__ + "img/no-msg.b6db1855.png";